<template>
  <div class="compliance-template pb-16">
    <div class="lg:max-w-7xl mx-auto px-8">
      <Crumbs :crumbs="crumbs" class="py-8" />
    </div>

    <div class="lg:max-w-3xl mx-auto block md:flex justify-between mb-20 px-8">
      <div class="small-container">
        <FormattedHeader header="What's the Law?" />
        <div class="documentation mb-20" v-html="theLaw"></div>
        <FormattedHeader header="Am I at Risk?" />
        <div class="documentation" v-html="theRisk"></div>
        <div class="documentation" v-html="disclaimer"></div>
      </div>
    </div>

    <Ribbon class="mb-10" />

    <div class="lg:max-w-7xl mx-auto mb-24 px-8">
      <WhatYouGet :benefits="benefits" class="mx-auto mb-10" />

      <EmployeeTypes class="mx-auto" />
    </div>
    <RegistrationPrompt
      button-id="company-size-button"
      class="mx-auto shadow-md"
    />
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  useMeta,
  useRoute,
} from '@nuxtjs/composition-api';
import Crumbs from '@/components/Crumbs.vue';
import Ribbon from '@/components/Ribbon.vue';
import WhatYouGet from '@/components/WhatYouGet.vue';
import EmployeeTypes from '@/components/EmployeeTypes.vue';
import FormattedHeader from '@/components/FormattedHeader.vue';
import RegistrationPrompt from '@/components/RegistrationPrompt';
import { benefits } from '@/modules/InformationPages/Industries/mocks/index';
import { Compliances } from '@/modules/InformationPages/Compliance/mocks/index';
import useGlobalSettings from '@/hooks/useGlobalSettings';

export default defineComponent({
  name: 'ComplianceTemplate',
  components: {
    Crumbs,
    EmployeeTypes,
    FormattedHeader,
    RegistrationPrompt,
    Ribbon,
    WhatYouGet,
  },
  layout: 'default',
  props: {
    complianceType: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const route = useRoute();
    const compliance = computed(() =>
      !props.complianceType
        ? Compliances[`${route.value.params.slug}`]
        : Compliances.wage_hour
    );
    const theLaw = computed(() => compliance.value.the_law || '');
    const theRisk = computed(() => compliance.value.the_risk || '');
    const disclaimer = computed(() => compliance.value.disclaimer || '');

    const crumbs = computed(() => [
      {
        label: 'Compliance',
        to: '/compliance',
      },
      {
        label: route.value?.params?.slug?.split('_').join(' '),
        to: `/compliance/${route.value.params.slug}`,
      },
    ]);
    const { setHeader, getHeader } = useGlobalSettings();

    setHeader({
      header: compliance.value.main_heading,
      subheader: compliance.value.main_subheading,
      heroImage: compliance.value.bg || null,
      metaTitle: compliance.value.main_heading,
      registration: true,
      noHero: false,
    });

    useMeta(() => ({ title: compliance.value.main_heading }));

    return {
      compliance,
      crumbs,
      benefits,
      getHeader,
      theLaw,
      theRisk,
      disclaimer,
    };
  },
  head() {},
});
</script>

<style scoped>
.documentation >>> ul {
  @apply list-disc list-inside my-2;
}
.documentation >>> ul ul {
  @apply pl-4 my-0;
}
.documentation >>> p.subheader {
  @apply font-bold mt-4 mb-2;
}
</style>
